import cx from 'classnames';
import React from 'react';
import styles from './styles.module.scss';

export default function Stack({ children, className, ...props }) {
  return (
    <div {...props} className={cx(styles.Stack, className)}>
      {children}
    </div>
  );
}
